module.exports = __webpack_public_path__ + "img/appstore.045ae2ed.png";